import React from 'react';
import {
  SaveButton,
  required,
  TextInput,
  usePermissions,
  Labeled,
  TextField,
} from 'react-admin';

import { useFormContext } from 'react-hook-form';

import {
  Box,
  Grid,
} from '@mui/material';

import hasAccess from '../../utilities/hasAccess';

import EditDialog from '../layout/dialog/EditDialog';

import ActivationButton from '../../customFields/ActivationButton';

import actions, { Actions } from '../../constants/actions';
import resourceTypes from '../../constants/resourceTypes';

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} marginTop={4}>
      {hasAccess(permissions, actions.SIGNAL_UPDATE_ACTIVATION) && (
        <ActivationButton />
      )}
      {hasAccess(permissions, actions.SIGNAL_UPDATE) && (
        <SaveButton
          disabled={!isValid}
          icon={null}
        />
      )}
    </Box>
  );
};

const SignalEdit = () => (
  <EditDialog
    customToolbar={<CustomToolbar />}
    title="signal"
    action={actions.SIGNAL_GET}
    resourceType={resourceTypes.SIGNAL}
  >
    <Grid container spacing={6}>
      <Grid size={12}>
        <Labeled label="ID">
          <TextField source="id" />
        </Labeled>
      </Grid>
      <Grid size={12}>
        <Labeled label="Name">
          <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
        </Labeled>
      </Grid>
    </Grid>
  </EditDialog>
);

export default SignalEdit;
